
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { name: '首页', path: '/' },
    { name: '关于我们', path: '/about' },
    { name: '产品系列', path: '/products' },
    { name: '三地精粹', path: '/regions' },
  ];

  const handleExploreClick = () => {
    navigate('/products');
  };

  return (
    <header className="relative shadow-sm sticky top-0 z-50 overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/b6f154f0a5ddd4ee680f68d928bef855.png')`,
          backgroundSize: '120px 120px',
          backgroundRepeat: 'repeat',
          backgroundPosition: '0 0'
        }}
      ></div>
      
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-white/85 backdrop-blur-sm"></div>
      
      <nav className="relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f21c56093101f07d70e4f03bb9372588.png" 
                  alt="狮虎堂 Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold text-[#2f3673]" style={{ fontFamily: '"Pacifico", serif' }}>狮虎堂</span>
                <span className="text-xs text-gray-500">LIONTIGER HUB</span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-[#f7931d] transition-colors duration-300 cursor-pointer font-medium">
              首页
            </a>
            <a href="/products" className="text-gray-700 hover:text-[#f7931d] transition-colors duration-300 cursor-pointer font-medium">
              产品系列
            </a>
            <a href="/regions" className="text-gray-700 hover:text-[#f7931d] transition-colors duration-300 cursor-pointer font-medium">
              三地精粹
            </a>
            <a href="/about" className="text-gray-700 hover:text-[#f7931d] transition-colors duration-300 cursor-pointer font-medium">
              关于狮虎堂
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button 
              onClick={handleExploreClick}
              className="bg-[#2f3673] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#1e2557] transition-colors duration-200 cursor-pointer whitespace-nowrap shadow-lg"
            >
              探索狮虎人生
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#f7931d] cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/90 backdrop-blur-sm border-t">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`block px-3 py-2 text-base font-medium transition-colors duration-200 cursor-pointer ${
                    location.pathname === item.path
                      ? 'text-[#f7931d] bg-orange-50'
                      : 'text-gray-700 hover:text-[#f7931d] hover:bg-gray-50'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-3 py-2">
                <button 
                  onClick={handleExploreClick}
                  className="w-full bg-[#2f3673] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#1e2557] transition-colors duration-200 cursor-pointer whitespace-nowrap shadow-lg"
                >
                  探索狮虎人生
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
